// src/lib/contentful.ts
import { createClient } from 'contentful';

export const ctfClient = createClient({
  space: process.env.REACT_APP_CTF_SPACE_ID!,
  accessToken: process.env.REACT_APP_CTF_CDA_TOKEN!,
});

// Types for your entries
export interface CtfBlogPost {
  sys: { id: string };
  fields: {
    title: string;
    slug: string;
    excerpt?: string;
    body?: any; // Rich Text JSON
    publishedAt: string; // ISO string
    authorName?: string;
    coverImage?: { fields: { file: { url: string } } };
  };
}
